import React from "react";
import Modal from "react-modal";

import * as S from "./styles";

Modal.setAppElement("#root");

const Newsletter = () => (
  <>
    <S.Wrapper>
      <S.Content>
        <S.Header>
          <S.Title>La newsletter</S.Title>
          <S.Intro>
            Tous les mardis, un digest design à la sauce Punktional, avec
            supplément inspi 🍦
          </S.Intro>
          <S.Link
            to={{ pathname: "https://punktional.substack.com/" }}
            target="_blank"
          >
            S'abonner à la newsletter
          </S.Link>
        </S.Header>
      </S.Content>
    </S.Wrapper>
    <S.Background />
  </>
);

export default Newsletter;
